export default {
	perfil: null,
	loader: false,
	error: false
}
	
